import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    location: 'Kerrville Resident',
    image: 'https://public.readdy.ai/ai/img_res/83407f3a4fb3774d7400730b3f77633c.jpg',
    quote: 'West Insurance made finding the right private health insurance plan so easy for my family. Their team took the time to explain all our options and helped us choose coverage that fits our healthcare needs and budget. As longtime Kerrville residents, we appreciate their local expertise and caring approach to health insurance.',
  },
  {
    id: 2,
    name: 'Michael Rodriguez',
    location: 'Small Business Owner, Kerr County',
    image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%20man%20in%20his%20thirties%20with%20friendly%20expression%20wearing%20business%20casual%20attire%20simple%20solid%20light%20blue%20background&width=500&height=500&seq=testimonial-health-002&orientation=squarish',
    quote: 'Providing health benefits for my employees was challenging until I found West Insurance. They helped us set up an affordable group health insurance plan that my team loves. Their knowledge of business health insurance options in Kerrville is exceptional, and they made the entire process stress-free.',
  },
  {
    id: 3,
    name: 'Jennifer Thompson',
    location: 'Medicare Client, Kerrville',
    image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20cheerful%20woman%20in%20her%20sixties%20with%20warm%20welcoming%20smile%20wearing%20casual%20attire%20simple%20solid%20light%20blue%20background&width=500&height=500&seq=testimonial-health-003&orientation=squarish',
    quote: 'Navigating Medicare was overwhelming until West Insurance guided me through every step. They explained Medicare Advantage, Supplement plans, and prescription drug coverage in terms I could understand. Their patience and expertise gave me confidence that I chose the right Medicare plan for my retirement in Kerr County.',
  },
];

export default function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const current = testimonials[currentIndex];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          {/* Left Image Area */}
          <div className="md:col-span-2">
            <div className="w-full h-96 md:h-[500px]">
              <img
                src={current.image}
                alt={`${current.name} - West Insurance health insurance client testimonial`}
                title={`${current.name} health insurance testimonial`}
                className="w-full h-full object-cover rounded-3xl shadow-2xl"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="md:col-span-3">
            <div className="mb-6">
              <span className="text-gray-400 text-xs font-medium tracking-wider">(CLIENT TESTIMONIAL)</span>
            </div>
            <h3 className="text-5xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
              <span className="text-gray-900">What Kerrville</span>
            </h3>
            <h3 className="text-5xl font-bold text-gray-400 mb-12" style={{ fontFamily: "'Playfair Display', serif" }}>
              Clients Say
            </h3>

            <div className="mb-8">
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                "{current.quote}"
              </p>
              <p className="text-gray-900 font-semibold text-base">
                — {current.name}, <span className="text-gray-600 font-normal">{current.location}</span>
              </p>
            </div>

            {/* Navigation Controls */}
            <div className="flex items-center gap-4">
              <button
                onClick={handlePrevious}
                className="w-12 h-12 border-2 border-gray-300 rounded-full flex items-center justify-center hover:border-[#0077B6] hover:text-[#0077B6] transition-all cursor-pointer"
                aria-label="Previous testimonial"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-12 h-12 bg-[#0077B6] text-white rounded-full flex items-center justify-center hover:bg-[#005F8C] transition-all cursor-pointer"
                aria-label="Next testimonial"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
              <span className="text-gray-500 text-sm ml-2">
                {currentIndex + 1} / {testimonials.length}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
